/**
 * Load More Pagination for Oakley Shopify Store
 * Handles progressive loading of products on collection and search pages
 */

function initLoadMoreButton() {
  const button = document.getElementById('load-more');
  const grid = document.getElementById('product-grid');
  const messageEl = document.getElementById('product-count-message');
  const progressBar = document.getElementById('product-progress-bar');
  const container = document.getElementById('ProductGridContainer');
  const wrapper = button ? (button.closest('.load-more-wrapper') || button.parentElement) : null;
  
  if (!button || !grid) {
    return; // Exit if required elements don't exist
  }

  const totalCount = parseInt(container?.dataset.totalProducts || 0);
  const pageSize = parseInt(container?.dataset.pageSize || 24);

  /**
   * Update the progress bar and message based on viewed products
   */
  function updateProgress() {
    // Count actual product items (using product-item custom element)
    const totalViewed = document.querySelectorAll('#product-grid product-item').length;
    
    // Update message text
    if (messageEl) {
      messageEl.innerText = `You're seeing ${totalViewed} of ${totalCount}`;
    }

    // Update progress bar width
    if (progressBar && totalCount > 0) {
      const progress = Math.min((totalViewed / totalCount) * 100, 100);
      progressBar.style.width = `${progress}%`;
    }

    // Update button text with next batch count (not total remaining)
    const remaining = Math.max(0, totalCount - totalViewed);
    const nextBatchCount = Math.min(pageSize, remaining);
    
    if (remaining > 0) {
      const text = `Load ${nextBatchCount} Products More`;
      const span = button.querySelector('span');
      if (span) {
        span.textContent = text;
      } else {
        button.innerHTML = `<span>${text}</span>`;
      }
    } else {
      const text = 'All Products Loaded';
      const span = button.querySelector('span');
      if (span) {
        span.textContent = text;
      } else {
        button.innerHTML = `<span>${text}</span>`;
      }
      button.disabled = true;
    }
  }

  // Initial progress update
  updateProgress();

  // Remove any existing click listener to prevent duplicate bindings
  const newButton = button.cloneNode(true);
  button.parentNode.replaceChild(newButton, button);

  // Add click event listener
  newButton.addEventListener('click', function () {
    const nextUrl = newButton.dataset.next;
    
    if (!nextUrl) {
      return;
    }

    // Update button state to loading (keep the text, just add loading class)
    newButton.classList.add('is-loading');
    newButton.disabled = true;

    // Fetch next page
    fetch(nextUrl)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const html = parser.parseFromString(data, 'text/html');
        
        // Find new products in the fetched HTML
        const newProducts = html.querySelectorAll('#product-grid product-item');

        // Append new products to the grid
        newProducts.forEach(product => {
          grid.appendChild(product);
        });

        // Check if there's another page
        const nextButton = html.querySelector('#load-more');
        if (nextButton && nextButton.dataset.next) {
          newButton.dataset.next = nextButton.dataset.next;
          newButton.classList.remove('is-loading');
          newButton.disabled = false;
        } else {
          // No more pages - remove the button or disable it
          newButton.dataset.next = '';
          newButton.classList.remove('is-loading');
          // Also hide the wrapper since there is no next page
          if (wrapper) wrapper.style.display = 'none';
        }

        // Update progress after loading new products
        updateProgress();
      })
      .catch(error => {
        console.error('Load more failed:', error);
        newButton.classList.remove('is-loading');
        newButton.disabled = false;
      });
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLoadMoreButton);
} else {
  initLoadMoreButton();
}

// Make function globally available for re-initialization after AJAX updates
window.initLoadMoreButton = initLoadMoreButton;
